import { render, staticRenderFns } from "./cExamRoom.vue?vue&type=template&id=f36370c8&scoped=true&"
import script from "./cExamRoom.vue?vue&type=script&lang=js&"
export * from "./cExamRoom.vue?vue&type=script&lang=js&"
import style0 from "./cExamRoom.vue?vue&type=style&index=0&id=f36370c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36370c8",
  null
  
)

export default component.exports